import { Pipe, PipeTransform } from '@angular/core';
import * as humanizeDuration from 'humanize-duration';
import { LeadStatusTransition } from 'src/app/core/models/lead/lead-status-transition.model';

@Pipe({
    name: 'humanizeTransitionSpan',
    standalone: false
})
export class HumanizeTransitionSpanPipe implements PipeTransform {

  transform(value: LeadStatusTransition): string {
    let timeSpanInMilliseconds = new Date(value.timeSpan[1])?.getTime() - new Date(value.timeSpan[0])?.getTime()

    if (isNaN(timeSpanInMilliseconds) || timeSpanInMilliseconds < 1000) return '-';

    const shortItalianHumanizer = humanizeDuration.humanizer({
      language: "shortIt",
      largest: 1,
      units: ['d', 'h', 'm', 's'],
      round: true,
      languages: {
        shortIt: {
          d: () => 'gg',
          h: () => 'ore',
          m: () => 'min',
          s: () => 'sec'
        },
      },
    });

    return shortItalianHumanizer(timeSpanInMilliseconds);

  }

}
